import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './Person.css'
import template from './Person.jinja'

var Person = Backbone.View.extend({
    events: {
        'mouseenter': 'hoverOn',
        'mouseleave': 'hoverOff'
    },

    initialize () {
        _.bindAll(this, 'restartVideo', 'reverse')

        this.$video = this.$('video')
        this.video = this.$video[0]
    },

    hoverOn() {
        if (this.hoverOffInterval) {
            clearInterval(this.hoverOffInterval)
        }

        this.video.play()
        this.$video.on('ended', this.restartVideo)
    },

    hoverOff() {
        this.video.pause()
        this.hoverOffInterval = setInterval(this.reverse, 40)
        this.$video.off('enwded', this.restartVideo)
    },

    reverse() {
        //this.video.currentTime = this.video.duration - this.video.currentTime;
        //this.paused = false;
        //} else {
        //    this.video.play();
        //    this.video.pause();
        //    if (this.video.buffered.end(0) === this.video.duration) {
        //        this.video = true;
        //        this.video.currentTime = this.video.duration - this.video.currentTime
        //    }
        //}

        this.video.currentTime -= 0.04

        if (this.video.currentTime <= 0) {
            clearInterval(this.hoverOffInterval)
        }
    },

    restartVideo() {
        this.video.currentTime = 0
        this.video.play()
    }
})

export default Person


// WEBPACK FOOTER //
// ./assets/app/front/components/Person/Person.js